import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { CopyIcon } from "../../../../svg/copy-icon";

interface CopyIconCellProps {
  value: string;
  [key: string]: any;
}

/**
 * Renders a copy-to-clipboard control for a row identifier or similar value.
 *
 * @param value - Text copied when the user clicks the control
 */
export const CopyIconCell: React.FC<CopyIconCellProps> = ({ value }) => {
  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling to parent table cell
    if (value) {
      navigator.clipboard.writeText(value);
      toast.success("Copied to clipboard");
    }
  };

  return (
    <div
      className="copy-icon-cell flex cursor-pointer items-center justify-center"
      onClick={handleCopy}
      title={value ? `Copy: ${value}` : "No value to copy"}
    >
      {value && <CopyIcon />}
    </div>
  );
};

export default CopyIconCell;
